import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import emoji from "react-easy-emoji";

import Header from "../header/header.js";
import { games } from "../../data/matchups.js";
import { put } from "../../api.js";

import styles from "./home.module.css";

let Game = ({ game }) => {
  let status = game.donezo()
    ? styles.over
    : game.teamA && game.teamB
    ? styles.active
    : game.teamA || game.teamB
    ? styles.halfActive
    : styles.inactive;
  let title = game.isFinals ? emoji(`🏆FINALS🏆`) : `Game ${game.number}`;

  return (
    <li className={status} key={game.number}>
      <span className={styles.date}>{game.endsOn}</span>
      <Link to={"/" + game.number.toString()}>
        {title}: {teamName(game.teamA)} vs {teamName(game.teamB)}
      </Link>
    </li>
  );
};

let StatusLegend = () => (
  <div className={styles.legend} role="presentation">
    <p className={styles.legendTitle}>Legend</p>
    <div>
      <div className={styles.activeDemo + " " + styles.demo} />
      <span className={styles.demoLabel}>Active</span>
    </div>
    <div>
      <div className={styles.halfActiveDemo + " " + styles.demo} />
      <span className={styles.demoLabel}>Waiting on another game</span>
    </div>
    <div>
      <div className={styles.overDemo + " " + styles.demo} />
      <span className={styles.demoLabel}>Votes are in</span>
    </div>
  </div>
);

let bracket = [];
let teamName = (team) => (team && team.owner) || "TBD";

for (let gameNumber in games) {
  let game = games[gameNumber];

  bracket.push(<Game key={game.number} game={game} />);
}

let Home = () => {
  useEffect(() => {
    window.games = games;
    window.put = put;

    let puttableGames = Object.keys(games).reduce((acc, k) => {
      let { number, endsOn, over, teamA, teamB } = games[k];

      return {
        ...acc,
        [k]: {
          number,
          endsOn,
          over,
          teamA: teamA && teamA.owner,
          teamB: teamB && teamB.owner,
        },
      };
    }, {});

    // console.log(puttableGames);
    // NOT GRANULAR ENOUGH
    // window.runit = () => put("/matchups.json", puttableGames);
  }, [games]);

  return (
    <>
      <StatusLegend />
      <div className={styles.container}>
        <Header />
        <ul className={styles.gameList}>
          <li>
            {" "}
            <span className={styles.date}>VOTING CLOSES AT 12P EDT</span>
          </li>
          {bracket}
        </ul>
      </div>
      <h2 className={styles.dot} role="presentation">
        .
      </h2>
      <h2 className={styles.dot} role="presentation">
        .
      </h2>
      <h2 className={styles.dot} role="presentation">
        .
      </h2>
    </>
  );
};

export default Home;
